//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    display: flex;
    align-items: center;
    position: relative;
    user-select: none;
    cursor: pointer;
    & svg {
        fill: var(--purple-2);
        transform: rotate(90deg);
        transition: 0.35s;
    }
    &.first-or-last {
        cursor: not-allowed;
        & svg {
            fill: var(--light-gray-6);
        }
    }
    &.next svg {
        transform: rotate(-90deg);
    }
    &:hover > *:last-child {
        visibility: visible;
        opacity: 1;
    }
`;